import type { Dispatch } from 'react';

import { ActionTypes } from '../../types/entities';
import type { DispatchAction } from '../actions';

import type LanguageLocales from '@helsenorge/core-utils/constants/languages';

export const setLanguage = (dispatch: Dispatch<DispatchAction>, language: LanguageLocales): void => {
  dispatch({ type: ActionTypes.SetLanguage, payload: { language } });
};
